export default {
      id: "check-intermediate-usage",
      viewBox: "0 0 14 14",
      url: "/" + "img/marilyn-ui.svg#check-intermediate",
      toString: function () {
        return this.url;
      }
    }